import moment from "moment";
import React from "react";
import { AiOutlineCalendar, AiOutlineClockCircle } from "react-icons/ai";
import { LuCircleDashed } from "react-icons/lu";
import { useTimer } from "react-timer-hook";
import { useNavigate } from "react-router-dom";
import { FaGavel } from "react-icons/fa";

function ProductCard({ item, setShowSingleProduct, setBidID }) {
  const navigate = useNavigate();
  // console.log(item?.bidEnd,'item?.bidEnd');
  // console.log(item,'item');
  

  const expiryTimestamp = new Date(item?.bidEnd);
  console.log(expiryTimestamp,"expiryTimestamp");
  
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp,
    onExpire: () => console.warn("onExpire called"),
  });
console.log(seconds, minutes, hours, days,"seconds, minutes, hours, days");

  const findStatus = (startDate, endDate, status) => {
    const currentDate = new Date().toISOString();

    if (status === "live" && startDate > currentDate) return "Scheduled";
    if (status === "live" && endDate < currentDate) return "Expired";
    if (status === "approved" && endDate < currentDate) return "Approved";
    else {
      return status;
    }
  };

  const handleViewDetail = (ID) => {
    navigate("/bid-detailed-view", { state: ID });
  };
  return (
    <div
      key={item._id}
      className="flex flex-col relative md:flex-row justify-start items-center bg-white rounded-2xl shadow-sm border border-gray-100 p-4 md:p-5 hover:shadow-md transition"
    >
      {/* Image Section */}
      <div className="w-full md:w-1/4 mb-4 md:mb-0">
        <div className="flex-shrink-0">
          <img
            src={item?.productImage[0].url}
            alt="Dodge Challenger Hellcat"
            className="h-[200px] w-full object-cover rounded-xl"
          />
        </div>
      </div>

      {/* Content Section */}
      <div
        className="flex-1 lg:w-2/3 px-0 md:px-6"
        onClick={() => handleViewDetail(item._id)}
      >
        <h2
          onClick={() => {
            setShowSingleProduct(true);
            setBidID(item._id);
          }}
          className="text-lg md:text-xl font-semibold text-gray-900 leading-tight text-start cursor-pointer"
        >
          {item.productName}
        </h2>
        <div className="flex flex-wrap gap-2 mt-3">
          <span className="px-3 py-1.5 text-xs font-medium rounded-lg bg-blue-50 text-blue-700">
            Lot No {item?._id?.slice(-4)}
          </span>
          <span className="px-3 py-1.5 text-xs font-medium rounded-lg bg-gray-50 text-gray-700">
            {item?.productName}
          </span>
          <span className="px-3 py-1.5 text-xs font-medium rounded-lg bg-gray-50 text-gray-700">
            {item?.category?.name}
          </span>
          <span className="px-3 py-1.5 text-xs font-medium rounded-lg bg-gray-50 text-gray-700">
            {item?.subCategory?.name}
          </span>
          {/* <span className="bg-[#EAEFFF] text-[#313131] text-[12px] font-semibold px-2 py-1 rounded-[2px]">{item.owner}</span> */}
        </div>

        <div className="w-full md:w-[420px] border-t border-[#E2E2E2] mt-5 pt-4 space-y-3">
          {/* Key info grid */}
          <div className="grid grid-cols-2 gap-y-2 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <AiOutlineCalendar className="w-4 h-4 text-gray-500" />
              <div>
                <p className="text-gray-400">Start Date</p>
                <p className="text-gray-900 font-medium">
                  {item?.bidStart
                    ? moment(item?.bidStart).format("DD-MM-YYYY")
                    : "NA"}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <FaGavel className="w-4 h-4 text-gray-500" />
              <div>
                <p className="text-gray-400">Bids</p>
                <p className="text-gray-900 font-medium">
                  {item.bidCount || "NA"}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <AiOutlineCalendar className="w-4 h-4 text-gray-500" />
              <div>
                <p className="text-gray-400">End Date</p>
                <p className="text-gray-900 font-medium">
                  {item?.bidEnd
                    ? moment(item?.bidEnd).format("DD-MM-YYYY")
                    : "NA"}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <FaGavel className="w-4 h-4 text-gray-500" />
              <div>
                <p className="text-gray-400">Type</p>
                <p className="text-gray-900 font-medium">
                  {item.type || "NA"}
                </p>
              </div>
            </div>
          </div>

          {/* Time left + status (same row, like before) */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-gray-600 mt-1">
            <div className="flex items-center gap-2">
              <AiOutlineClockCircle className="w-4 h-4 text-gray-500" />
              <span className="text-gray-400">
                Time Left
              </span>
              <span className="text-gray-900 font-medium">
                {`${days}d: ${hours}h: ${minutes}m: ${seconds}s`}
              </span>
            </div>
            <div className="flex items-center gap-2 mt-1 md:mt-0">
              <LuCircleDashed className="w-4 h-4 text-green-700" />
              <span className="px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-700">
                {findStatus(item.bidStart, item.bidEnd, item.status)}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bid Section */}
      <div className="mt-4 md:mt-0 w-full md:w-auto lg:w-1/5 flex flex-col items-stretch">
        <div className="bg-gray-50 rounded-xl p-4 text-center border border-gray-200 w-full">
          <div className="text-xs text-gray-500 uppercase tracking-wide">
            Current Bid
          </div>
          <div className="text-2xl font-bold text-gray-900 mt-1">
            {item.bidLivePrice || "NA"}
          </div>

          <div className="mt-4">
            <div className="text-xs text-gray-500 uppercase tracking-wide">
              Starting Bid
            </div>
            <div className="text-lg font-semibold text-gray-700 mt-1">
              {item.initialPrice || "NA"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
